import { AppButton } from '@clickguard/design-system'
import { useParams } from 'react-router-dom'
import Logo from '../../assets/img/cg-logo-white.svg'
import { ChatService } from '../../services/chat'
import { ProfileDropdown } from 'components/profile-dropdown'
import { useNavigateWithParams, useStores } from 'hooks'
import { useMemo } from 'react'

interface OnboardingHeaderProps {
	variant?: 'sign-in' | 'sign-up'
}

export const OnboardingHeader = ({
	variant = 'sign-up'
}: OnboardingHeaderProps) => {
	const { accountId } = useParams()
	const { accountStore } = useStores()
	const navigate = useNavigateWithParams()
	const { accounts } = accountStore
	const isNewWorkspace = useMemo(() => {
		if (accountId) {
			return accounts.length === 1
		}
		return accounts.length === 0
	}, [accountId, accounts])
	return (
		<header className="sticky top-[var(--cg-top-banner-h,0px)] left-0 w-full z-20 bg-[#111553] px-5 py-[14px]">
			<div className="flex items-center justify-between">
				<img alt="ClickGuard" className="h-[24px] w-[156px]" src={Logo} />
				{variant === 'sign-up' && (
					<div className="flex items-center gap-4">
						{isNewWorkspace ? (
							<>
								<div className="hidden md:block">
									<AppButton
										variant="marketing"
										size="md"
										label="Chat with us"
										leftIcon={
											<svg
												xmlns="http://www.w3.org/2000/svg"
												width="16"
												height="16"
												viewBox="0 0 20 20"
												fill="none"
											>
												<path
													fillRule="evenodd"
													clipRule="evenodd"
													d="M2.50012 9.58332C2.50012 5.21107 6.04453 1.66666 10.4168 1.66666C14.789 1.66666 18.3335 5.21107 18.3335 9.58332C18.3335 13.9556 14.789 17.5 10.4168 17.5C9.41543 17.5 8.45562 17.3137 7.5715 16.9731C7.49571 16.9439 7.4518 16.927 7.41942 16.9154C7.41546 16.9139 7.41203 16.9127 7.40912 16.9117L7.40573 16.912C7.37938 16.914 7.34341 16.9176 7.27461 16.9248L2.9788 17.3688C2.80033 17.3873 2.61414 17.4066 2.45842 17.4084C2.30363 17.4102 2.02464 17.4015 1.75714 17.2383C1.44357 17.047 1.23 16.7275 1.17314 16.3646C1.12464 16.055 1.22321 15.7939 1.28407 15.6516C1.34529 15.5084 1.4343 15.3437 1.51963 15.1859L2.89619 12.6379C2.95574 12.5277 2.98757 12.4684 3.00899 12.4242C3.01012 12.4219 3.01116 12.4197 3.01212 12.4177C3.01051 12.4119 3.00856 12.4051 3.00621 12.3971C2.98817 12.3361 2.96041 12.2533 2.91325 12.1133C2.64511 11.3178 2.50012 10.4667 2.50012 9.58332Z"
													fill="#111553"
												/>
											</svg>
										}
										onClick={() => ChatService.open()}
									/>
								</div>
							</>
						) : (
							<>
								<p
									className="hidden md:block text-white text-md leading-[20px] font-normal cursor-pointer"
									onClick={() => navigate('/')}
								>
									Back to dashboard
								</p>
							</>
						)}

						<ProfileDropdown />
					</div>
				)}
			</div>
		</header>
	)
}
